import axios from "axios";

let basePath;
if (process.env.REACT_APP_ENV === "local") {
  basePath = process.env.REACT_APP_BACKEND_LOCAL;
} else {
  basePath = process.env.REACT_APP_BACKEND_PROD;
}

const client = axios.create({
  withCredentials: true,
  baseURL: basePath,
  headers: {
    "Content-Type": "application/json",
  },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default client;
